import { create } from 'zustand';

import type { Season } from '../lib/seasonsApi';


const STORAGE_KEY = 'currentSeasonId';

const storedSeasonId = (): string | null => {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(STORAGE_KEY);
};

export const resolveSelectedSeason = (seasons: Season[], selectedSeasonId: string | null): Season | null => {
  const selected = seasons.find(season => season.id === selectedSeasonId);
  return selected || seasons.find(season => season.status === 'active') || null;
};

export const teamBelongsToSeason = (team: { seasonId?: string }, seasonId?: string): boolean =>
  Boolean(seasonId) && team.seasonId === seasonId;

export const resolveOnlyTeamForSeason = <T extends { id: string; seasonId?: string }>(
  teams: T[],
  seasonId: string | null,
  currentTeamId: string | null,
): string | null => {
  if (!seasonId) return null;
  const seasonTeams = teams.filter(team => team.seasonId === seasonId);
  if (seasonTeams.some(team => team.id === currentTeamId)) return null;
  return seasonTeams.length === 1 ? seasonTeams[0].id : null;
};

interface SeasonState {
  selectedSeasonId: string | null;
  setSelectedSeasonId: (seasonId: string | null) => void;
}

export const useSeasonStore = create<SeasonState>((set) => ({
  selectedSeasonId: storedSeasonId(),
  setSelectedSeasonId: (seasonId) => {
    if (typeof localStorage !== 'undefined') {
      if (seasonId) localStorage.setItem(STORAGE_KEY, seasonId);
      else localStorage.removeItem(STORAGE_KEY);
    }
    set({ selectedSeasonId: seasonId });
  },
}));
